export const I18N_CONFIG = {
  defaultLanguage: 'es',
  showLanguageSwitch: true,
};

